/**
 * @generated SignedSource<<8a29ffa353d4ec8a5a294b5e673b5a28>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnsweringTypeV2 = "allowMultipleAnswersAllCorrectMustBeGiven" | "allowMultipleAnswersOnlySomeCorrectMustBeGiven" | "allowOnlyOneAnswer";
export type ClozeTextPartKind = "cloze" | "text";
export type ElementStateKind = "Input" | "InputAndIsCorrect" | "ShowAnswer" | "Untouched" | "UntouchedAndPreviouslyIncorrect";
export type ElementTypeV2 = "clozeText" | "dynamicVocab" | "enhancedText" | "file" | "globalVocab" | "markMistakes" | "matrix" | "multipleChoice" | "order" | "podcast" | "podcastWithTimestamp" | "text" | "video";
export type lessonInsights_Query$variables = {
  submissionId: string;
};
export type lessonInsights_Query$data = {
  readonly Viewer: {
    readonly Learn: {
      readonly getAnswers: ReadonlyArray<{
        readonly __typename: string;
        readonly correctAnswerIndices?: ReadonlyArray<number>;
        readonly correctAnswers?: ReadonlyArray<string>;
        readonly correctIndices?: ReadonlyArray<{
          readonly index: number;
          readonly xIdx: number;
          readonly yIdx: number;
        }>;
        readonly correctMistakeIndices?: ReadonlyArray<number>;
        readonly correctOrder?: ReadonlyArray<string>;
        readonly element: {
          readonly answeringType?: AnsweringTypeV2;
          readonly answeringTypeText?: string | null;
          readonly elementType: ElementTypeV2;
          readonly id: string;
          readonly parts?: ReadonlyArray<{
            readonly id: string;
            readonly kind: ClozeTextPartKind;
            readonly text?: string;
          }>;
          readonly question?: string;
          readonly shuffledAnswers?: ReadonlyArray<{
            readonly id: string;
            readonly text: string;
          }>;
          readonly text?: string;
          readonly title: string;
          readonly " $fragmentSpreads": FragmentRefs<"clozeTextLearnElement_ClozeTextLearnElementFragment" | "markMistakesLearnElement_MarkMistakesLearnElementFragment" | "multipleChoiceLearnElement_MultipleChoiceLearnElementFragment" | "orderLearnElement_OrderLearnElementFragment">;
        };
        readonly kind: ElementStateKind;
        readonly lastCheckedAnswerIndices?: ReadonlyArray<number> | null;
        readonly lastCheckedAnswers?: ReadonlyArray<string>;
        readonly lastCheckedIndices?: ReadonlyArray<{
          readonly index: number;
          readonly xIdx: number;
          readonly yIdx: number;
        }> | null;
        readonly lastCheckedMistakeIndices?: ReadonlyArray<number> | null;
        readonly lastSelectedOrder?: ReadonlyArray<string>;
      }>;
    };
  };
};
export type lessonInsights_Query = {
  response: lessonInsights_Query$data;
  variables: lessonInsights_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "contentSubmissionId",
    "variableName": "submissionId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "elementType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "TextPart",
  "abstractKey": null
},
v10 = [
  (v4/*: any*/),
  (v7/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "ClozeAnswer",
  "kind": "LinkedField",
  "name": "shuffledAnswers",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "EnhancedTextLearnElement",
  "abstractKey": null
},
v13 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "question",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answeringType",
      "storageKey": null
    }
  ],
  "type": "MultipleChoiceLearnElement",
  "abstractKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answeringTypeText",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    (v14/*: any*/)
  ],
  "type": "OrderLearnElement",
  "abstractKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctAnswers",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastCheckedAnswers",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctMistakeIndices",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastCheckedMistakeIndices",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "index",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "xIdx",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "yIdx",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MatrixLearnElementIndexCell",
      "kind": "LinkedField",
      "name": "correctIndices",
      "plural": true,
      "selections": [
        (v20/*: any*/),
        (v21/*: any*/),
        (v22/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MatrixLearnElementIndexCell",
      "kind": "LinkedField",
      "name": "lastCheckedIndices",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v21/*: any*/),
        (v20/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MatrixShowAnswerElementState",
  "abstractKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctAnswerIndices",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastCheckedAnswerIndices",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "correctOrder",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSelectedOrder",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "lessonInsights_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnViewerSchema",
            "kind": "LinkedField",
            "name": "Learn",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getAnswers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "element",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "parts",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "type": "ClozeTextLearnElement",
                        "abstractKey": null
                      },
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "clozeTextLearnElement_ClozeTextLearnElementFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "type": "ClozeTextShowAnswerElementState",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "markMistakesLearnElement_MarkMistakesLearnElementFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MarkMistakesShowAnswerElementState",
                    "abstractKey": null
                  },
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "multipleChoiceLearnElement_MultipleChoiceLearnElementFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MultipleChoiceShowAnswerElementState",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "orderLearnElement_OrderLearnElementFragment"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OrderShowAnswerElementState",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lessonInsights_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearnViewerSchema",
            "kind": "LinkedField",
            "name": "Learn",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": null,
                "kind": "LinkedField",
                "name": "getAnswers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "element",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "parts",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/),
                              (v3/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v11/*: any*/)
                        ],
                        "type": "ClozeTextLearnElement",
                        "abstractKey": null
                      },
                      (v12/*: any*/),
                      (v13/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "type": "ClozeTextShowAnswerElementState",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "MarkMistakes_Snippet",
                                "kind": "LinkedField",
                                "name": "snippets",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "content",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MarkMistakesLearnElement",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MarkMistakesShowAnswerElementState",
                    "abstractKey": null
                  },
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v14/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AnswerOptionWithoutCorrect",
                                "kind": "LinkedField",
                                "name": "answerOptions",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "answer",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "image",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "url",
                                        "storageKey": null
                                      },
                                      (v4/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "MultipleChoiceLearnElement",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "MultipleChoiceShowAnswerElementState",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v26/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "element",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "OrderItem",
                                "kind": "LinkedField",
                                "name": "orderItems",
                                "plural": true,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "OrderLearnElement",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "OrderShowAnswerElementState",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "745d8145479e5b2e3e293226ec8e20df",
    "id": null,
    "metadata": {},
    "name": "lessonInsights_Query",
    "operationKind": "query",
    "text": "query lessonInsights_Query(\n  $submissionId: ID!\n) {\n  Viewer {\n    Learn {\n      getAnswers(contentSubmissionId: $submissionId) {\n        __typename\n        kind\n        element {\n          __typename\n          id\n          title\n          elementType\n          ... on ClozeTextLearnElement {\n            parts {\n              __typename\n              id\n              kind\n              ... on ClozePart {\n                id\n                kind\n              }\n              ... on TextPart {\n                id\n                kind\n                text\n              }\n            }\n            shuffledAnswers {\n              id\n              text\n            }\n          }\n          ... on EnhancedTextLearnElement {\n            text\n          }\n          ... on MultipleChoiceLearnElement {\n            question\n            answeringType\n          }\n          ... on OrderLearnElement {\n            answeringTypeText\n          }\n        }\n        ... on ClozeTextShowAnswerElementState {\n          element {\n            __typename\n            ...clozeTextLearnElement_ClozeTextLearnElementFragment\n            id\n          }\n          correctAnswers\n          lastCheckedAnswers\n          kind\n        }\n        ... on MarkMistakesShowAnswerElementState {\n          correctMistakeIndices\n          lastCheckedMistakeIndices\n          kind\n          element {\n            __typename\n            ...markMistakesLearnElement_MarkMistakesLearnElementFragment\n            id\n          }\n        }\n        ... on MatrixShowAnswerElementState {\n          kind\n          correctIndices {\n            index\n            xIdx\n            yIdx\n          }\n          element {\n            __typename\n            title\n            id\n            elementType\n          }\n          lastCheckedIndices {\n            yIdx\n            xIdx\n            index\n          }\n        }\n        ... on MultipleChoiceShowAnswerElementState {\n          correctAnswerIndices\n          lastCheckedAnswerIndices\n          kind\n          element {\n            __typename\n            ...multipleChoiceLearnElement_MultipleChoiceLearnElementFragment\n            id\n          }\n        }\n        ... on OrderShowAnswerElementState {\n          correctOrder\n          lastSelectedOrder\n          kind\n          element {\n            __typename\n            ...orderLearnElement_OrderLearnElementFragment\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment clozeTextLearnElement_ClozeTextLearnElementFragment on ClozeTextLearnElement {\n  id\n  title\n  parts {\n    __typename\n    id\n    kind\n    ... on TextPart {\n      text\n    }\n  }\n  shuffledAnswers {\n    id\n    text\n  }\n  __typename\n  elementType\n}\n\nfragment markMistakesLearnElement_MarkMistakesLearnElementFragment on MarkMistakesLearnElement {\n  id\n  title\n  snippets {\n    content\n  }\n}\n\nfragment multipleChoiceLearnElement_MultipleChoiceLearnElementFragment on MultipleChoiceLearnElement {\n  question\n  answeringType\n  answeringTypeText\n  answerOptions {\n    answer\n    image {\n      url\n      id\n    }\n  }\n}\n\nfragment orderLearnElement_OrderLearnElementFragment on OrderLearnElement {\n  id\n  title\n  answeringTypeText\n  orderItems {\n    id\n    text\n  }\n}\n"
  }
};
})();

(node as any).hash = "b991e60d18d71cb1574c46aeaf79dbaa";

export default node;
